import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import { download } from "../../reduxSetup/action";
import PropTypes from "prop-types";
import styles from "./ToolsContainer.module.scss";

const ToolsContainer = ({ download }) => {
  const history = useNavigate();
  const TYPES = [
    { value: "media", label: "Media" },
    { value: "NGO", label: "NGO" },
    { value: "business", label: "Business" },
    { value: "government", label: "Government" },
    { value: "hotSpot", label: "Hot spot" },
    { value: "greenSpot", label: "Green spot" },
    { value: "news", label: "News" },
    { value: "blog", label: "Blog" },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.inline}>
        <Button
          className={styles.addNewButton + " " + styles.addNewButtonAdd}
          onClick={() => history("/categories")}
        >
          Add category text
        </Button>
        <Button
          className={styles.addNewButton + " " + styles.addNewButtonAdd}
          onClick={() => history("/premium-plan")}
        >
          Add premium plan
        </Button>
      </div>
      <Button
        className={styles.addNewButton + " " + styles.addNewButtonAdd}
        onClick={() => history("/text-compiler")}
      >
        Text Compiler
      </Button>
      <div className={styles.siteMapsContainer}>
        <h2>Generate site maps</h2>
        <ul>
          {TYPES.map((type) => (
            <li key={type.value}>
              {" "}
              <Button
                onClick={() => {
                  download(type.value);
                }}
              >
                {type.label}
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

ToolsContainer.propTypes = {
  download: PropTypes.func,
};

const mapDispatchToProps = {
  download,
};

export default connect(null, mapDispatchToProps)(ToolsContainer);
